import polygon from '../../assest/ahbaab/Clean Room Consumables banner.jpg'
import { Box } from "@mui/material"
import '../../styles/ahbaab/AboutUsStyle.css'
import Header from '../../common/ahbaab/Header/Header'
import Footer from '../../common/ahbaab/Footer/Footer'



const PrivacyPolicy = () => {

    return (
        <>
            <Header />

            <Box className='Aboutus_topdiv'>
                <img src={polygon} alt="img" />
                <div className="hosp_aboutushead">
                    <h1>Privacy Policy</h1>
                </div>
            </Box>

            <div className=" bg-light-subtle p-5">
                <div className="">
                    <p className=" fw-bold">Privacy Policy</p>
                    <p>A privacy policy states how you will respect the privacy of your website users. It says what information you will gather, how you will use it and how you will keep it secure.</p>
                    <p>A privacy policy is a legal document that discloses some or all of the ways a party gathers, uses, discloses and manages a customer's data. The exact contents of a privacy policy will depend upon the applicable law and may need to address the requirements of multiple countries or jurisdictions. While there is no universal guidance for the content of specific privacy policies, a number of organizations provide example forms.</p>
                    <p>This policy applies where we are acting as a data controller with respect to the personal data of our website visitors and service users; in other words, where we determine the purposes and means of the processing of that personal data. This policy applies to all of our websites.</p>
                </div>
            </div>


            <Footer />

        </>
    )
}

export default PrivacyPolicy